import { Link, useLocation } from "react-router-dom";
import { Sprout } from "lucide-react";

export function Navbar() {
  const { pathname } = useLocation();
  const onBooking = pathname.startsWith("/book");
  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/5"
      data-testid="main-navbar"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="grid place-items-center w-9 h-9 rounded bg-primary text-primary-foreground">
            <Sprout className="w-5 h-5" />
          </span>
          <span className="font-display font-extrabold tracking-tight text-lg leading-none text-foreground">
            Help!
          </span>
        </Link>
        {!onBooking && (
          <div className="flex items-center gap-3 sm:gap-5">
            <Link
              to="/my-bookings"
              data-testid="nav-my-bookings"
              className="text-sm font-bold text-foreground/70 hover:text-primary transition-colors hidden sm:block"
            >
              My bookings
            </Link>
            <Link
              to="/book"
              data-testid="nav-book-button"
              className="text-sm font-bold uppercase tracking-[0.15em] px-5 py-2.5 rounded bg-primary text-primary-foreground transition-transform active:scale-95 hover:bg-primary/90"
            >
              Book Now
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
